export default __webpack_public_path__ + "static/media/back.0348f0d1.jpg";